export function hideLoader() {
    const loader = document.getElementById("loader");
    if (loader) {
        loader.classList.add("hidden");
        // remove not consume CPU
        setTimeout(() => loader.remove(), 2000);
    }
}